import { setTokens } from "@src/app/authSlice";
import { setUserDetails } from "@src/app/globalSlice";
import { decryptData } from "@src/utils/crypto";
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");
  const tokens = useMemo(
    () => ({ accessToken, refreshToken }),
    [accessToken, refreshToken]
  );

  const dispatch = useDispatch();

  const encryptedUser = localStorage.getItem("userDetails");
  let userData = null;
  let decryptionFailed = false;
  if (encryptedUser) {
    try {
      userData = decryptData(encryptedUser);
    } catch (e) {
      console.error("Failed to decrypt userDetails in ProtectedRoute:", e);
      localStorage.removeItem("userDetails");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      decryptionFailed = true;
    }
  }

  useEffect(() => {
    if (userData) {
      dispatch(setTokens(tokens));
      dispatch(setUserDetails(userData));

      const app = (window as any).electronApp;
      if (app && typeof app.setSession === "function") {
        app.setSession({
          accessToken: tokens.accessToken,
          userId: userData.id,
          studentId: userData.id,
          studentName: userData.name || userData.username || "",
        });
      }
    }
  }, [userData, tokens, dispatch]);

  if (decryptionFailed || !accessToken) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
